import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHatenabookmarkComponent } from './simple-icons-hatenabookmark.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHatenabookmarkComponent ],
    exports:      [ SimpleIconsHatenabookmarkComponent ],
    bootstrap:    []
})
export class SimpleIconsHatenabookmarkModule {}
